import React, { useRef, useState, useEffect } from 'react'
// import { Link } from 'gatsby'
import cn from 'classnames'

import getPrefixedPath from '~/utils/getPrefixedPath'

import Q from '~/components/question/kv'
import Attention from '~/assets/svg/nanno.svg'

import s from './styles.module.scss'

type Item = {
  imgPc: string
  imgSp: string
  title: string | JSX.Element
  caption: string | JSX.Element
}
type Props = {
  items: Item[]
}

const Component: React.FC<Props> = ({ items }) => {
  const [index, setIndex] = useState(-1)
  const [show, setShow] = useState(false)
  const qPos = useRef(0) //Math.random() * 3 | 0)

  const item =
    index == -1
      ? {
          imgPc: '/assets/images/pc/p-pc-gray.jpg',
          imgSp: '/assets/images/sp/p-sp-gray.jpg',
          title: '',
          caption: '',
        }
      : items[index]

  useEffect(() => {
    setIndex((Math.random() * items.length) | 0)
  }, [])

  const onClick = () => {
    // debug
    // if (show) setIndex(index + 1 >= items.length ? 0 : index + 1)

    setShow(!show)
  }

  return (
    <div
      className={cn(s.kv, { [s.show]: show, kvShow: show })}
      onClick={onClick}
    >
      <figure>
        <picture>
          <source
            media="(min-width: 720px)"
            srcSet={getPrefixedPath(item.imgPc)}
          />
          <img src={getPrefixedPath(item.imgSp)} />
        </picture>
        <figcaption>
          <h2>{item.title}</h2>
          <p>{item.caption}</p>
        </figcaption>
      </figure>

      <div className={cn(s.attention)}>
        <Attention />
      </div>

      <div className={cn({ [s[`qPos_${qPos.current}`]]: true })}>
        <div className={cn(s.q)}>
          <Q shape={show ? 'bkv' : 'q'} delay={show ? 0 : 0} />
        </div>
        <div className={cn(s.q)}>
          <Q shape="q" delay={0} />
        </div>
        <div className={cn(s.q)}>
          <Q shape="q" delay={0} />
        </div>
        <div className={cn(s.q)}>
          <Q shape="q" delay={0} />
        </div>
        <div className={cn(s.q)}>
          <Q shape="q" delay={0} />
        </div>
      </div>
    </div>
  )
}

export default Component
